import { Product } from './types';

export const PRODUCTS: Product[] = [
  {
    imageUrl: '/static/demo/img/products/drill.png',
    productName: 'Drill',
    price: 500,
  },
  {
    imageUrl: '/static/demo/img/products/lawn-mower.png',
    productName: 'Lawn Mower',
    price: 1750,
  },
  {
    imageUrl: '/static/demo/img/products/generator.png',
    productName: 'Generator',
    price: 1250,
  },
];
